<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="footer-logo">
          <img src="assets/images/smalllogo-footer.png" alt="pdf to word" class="footer-logo-img">
        </div>
      </div>
      <div class="col-md-4">
        <div class="footer-menu">
          <p class="footer-title">Menu Général</p>
          <ul>
            <li><a href="/conditions-generales-ventes">Conditions générales</a></li>
            <li><a href="/politique-de-confidentialite">Politique de confidentialité</a></li>
            <li><a href="/mentions-legales">Mentions légales</a></li>
          </ul>
        </div>
      </div>
      <div class="col-md-4">
        <div class="footer-info">
          <p class="footer-title">Informations</p>
          <ul>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/login">Se connecter</a></li>
            <li><a href="/contact">Contactez-nous</a></li>
            <li><a href="/tarification">Tarification</a></li>
            <li><a href="/unsubscribe">Se désabonner</a></li>
            <li><a href="/supprimer-mes-donnees-personnelles">Supprimer mes données</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <div class="footer-copyright">
          <p>&copy; 2025 pdf to word</p>
        </div>
      </div>
    </div>
  </div>
</footer>
